import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { PostClosingDashboard } from '../components';

export const getPostClosingRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    postClosingDashboard: {
      path: `${basePath}/post-closing/dashboard`,
      url: `${baseUrl}/post-closing/dashboard`,
      documentTitle: 'Post Closing Dashboard',
    },
  };
};

export const getPostClosingRoutes = (basePath: string, baseUrl: string) => {
  const config = getPostClosingRoutesConfig(basePath, baseUrl);

  return {
    postClosingDashboard: (
      <Route exact path={config.postClosingDashboard.path}>
        <Page routeDefinition={config.postClosingDashboard}>
          <PostClosingDashboard />
        </Page>
      </Route>
    ),
  };
};